import { Component, Input, Output, EventEmitter, input, signal, OnInit, inject } from "@angular/core";
import { ButtonComponent } from "../button/button.component";
import { MatRipple } from "@angular/material/core";
import { ManagedModalDirective } from "../managed-modal/managed-modal.directive";
import { MatRadioModule } from "@angular/material/radio";
import { LogService } from "../../service/logging/log.service";

@Component({
    selector: "app-select-one-radio",
    templateUrl: "./select-one-radio.component.html",
    styleUrls: ["./select-one-radio.component.scss"],
    standalone: true,
    imports: [
        ManagedModalDirective,
        MatRipple,
        ButtonComponent,
        MatRadioModule,
    ],
})
export class SelectOneRadioComponent implements OnInit{
  @Input() dialogTitle: string;
  @Input() dialogSubtitle: string;
  @Input() visible: boolean;
  possibilities = input.required<string[]>();
  cancelBehavior = input.required<() => void>();

  @Output() answered = new EventEmitter<string>();

  private selected = signal<string>("");
  private logger = inject(LogService);

  ngOnInit(): void {
    if (this.possibilities().length > 0)
      this.selected.set(this.possibilities()[0])
  }

  onConfirm() {

    this.logger.debug("confirming this: ", this.selected());
    this.answered.emit(this.selected());
  }

  onCancel() {
    let func = this.cancelBehavior();
    func();
    this.answered.emit(null);
  }

  updateValue(newValue: string): void {
    this.logger.debug("Changed to: ", newValue);
    this.selected.set(newValue);
  }
}
